module.exports = __webpack_public_path__ + "static/media/playerImg.9c0e2949.svg";